export default class CycleschemeRedemptionForm {
  constructor(element) {
    this.element = element;

    this.baseUri = this.element.getAttribute('action');

    this.inputs = {
      group: this.element.querySelector('[data-input-group]'),
      certificateCode: this.element.querySelector(
        'input[name="certificate_code"]'
      ),
      redemptionCode: this.element.querySelector(
        'input[name="redemption_code"]'
      ),
    };

    this.initialiseEventListeners();
  }

  get certificateCode() {
    return this.inputs.certificateCode.value;
  }

  get redemptionCode() {
    return this.inputs.redemptionCode.value;
  }

  get submitButton() {
    return this.element.querySelector('button[type="submit"]');
  }

  get errorMessage() {
    return this.element.querySelector('[data-error-message]');
  }

  get successMessage() {
    return this.element.querySelector('[data-success-message]');
  }

  request(endpoint, method = 'POST') {
    return fetch(`${this.baseUri}/api/certificate/${endpoint}`, {
      method,
      mode: 'cors',
    });
  }

  redeemCertificate() {
    const certificateCode = this.inputs.certificateCode.value;
    const redemptionCode = this.inputs.redemptionCode.value;

    this.request(`redeem/${certificateCode}/${redemptionCode}`)
      .then(response => {
        if (response.ok) {
          return response.json();
        }

        this.toggleFormEnabled(true);

        throw new Error(
          response.headers.get('x-ebikeshop-cyclescheme-middleware-error')
        );
      })
      .then(body => this.onCertificateRedemptionSuccess(body.voucher_code))
      .catch(e => this.onCertificateRedemptionFail(e));
  }

  /** @param {Error} error */
  onCertificateRedemptionFail(error) {
    this.setErrorMessage(error.message);
  }

  onCertificateRedemptionSuccess(voucherCode) {
    this.applyDiscountCode(voucherCode).then(response => {
      if (!response.ok) {
        // Try again
        return this.onCertificateRedemptionSuccess(voucherCode);
      }

      this.inputs.group.classList.add('hidden');

      this.successMessage.classList.remove('hidden');
      this.successMessage.innerHTML = `
         Success! <br /> Your Cyclescheme certificate has been redeemed and the voucher
         code <strong>${voucherCode}</strong> has been applied to your order.
      `;

      return true;
    });
  }

  clearErrorMessage() {
    this.errorMessage.classList.add('invisible');
    this.errorMessage.innerText = '&nbsp;';
    this.inputs.certificateCode.classList.remove('border-[#f80003]');
    this.inputs.redemptionCode.classList.remove('border-[#f80003]');
  }

  setErrorMessage(message) {
    this.errorMessage.classList.remove('invisible');
    this.errorMessage.innerText = message;
    this.inputs.certificateCode.classList.add('border-[#f80003]');
    this.inputs.redemptionCode.classList.add('border-[#f80003]');
  }

  /**
   * @param {String} voucherCode
   */
  // eslint-disable-next-line class-methods-use-this
  applyDiscountCode(voucherCode) {
    return fetch(`/discount/${voucherCode}`);
  }

  /** Show or hide the form's container */
  toggleFormVisibility() {
    this.element.parentElement.classList.toggle('!h-0');
  }

  toggleFormEnabled(enabled = true) {
    this.submitButton.toggleAttribute('disabled', !enabled);
    this.submitButton.classList.toggle('disabled', !enabled);
  }

  initialiseEventListeners() {
    this.element.parentElement.previousElementSibling.addEventListener(
      'click',
      () => this.toggleFormVisibility()
    );

    this.element.addEventListener('submit', e => {
      e.preventDefault();
      this.clearErrorMessage();
      this.toggleFormEnabled(false);
      this.redeemCertificate();
    });
  }
}
